import React from 'react';
import PropTypes from 'prop-types';
import {makeStyles} from 'tss-react/mui';
import {FormattedMessage} from 'react-intl';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import {useRenewalClick} from '../context/RenewalClickContext';
import whatsappIcon from '../../../assets/whatsapp-icon.svg';

const useStyles = makeStyles()((theme) => ({
  container: {
    padding: '48px 20px',
    maxWidth: 520,
    margin: '0 auto',
    textAlign: 'center',
  },
  iconWrapper: {
    width: 80,
    height: 80,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: '0 auto 24px',
  },
  warningBg: {
    backgroundColor: theme.palette.warning.light,
  },
  warningIcon: {
    fontSize: 48,
    color: theme.palette.warning.main,
  },
  title: {
    fontSize: theme.typography.pxToRem(22),
    fontWeight: 700,
    fontFamily: 'Ploni, Arial, sans-serif',
    color: theme.palette.secondary.main,
    marginBottom: 12,
  },
  subtitle: {
    fontSize: theme.typography.pxToRem(16),
    fontFamily: 'Ploni, Arial, sans-serif',
    color: theme.palette.text.secondary,
    marginBottom: 24,
    lineHeight: 1.5,
  },
  whatsappBtn: {
    backgroundColor: '#25D366',
    color: '#fff',
    fontWeight: 700,
    fontFamily: 'Ploni, Arial, sans-serif',
    borderRadius: 30,
    padding: '10px 28px',
    '&:hover': {backgroundColor: '#1da851'},
  },
  whatsappIcon: {
    width: 20,
    height: 20,
    marginInlineEnd: 8,
  },
}));

const VARIANT_CONFIG = {
  expired: {prefix: 'renewalClick.expired'},
  invalid: {prefix: 'renewalClick.invalid'},
};

const InvalidLinkScreen = ({variant = 'invalid'}) => {
  const {classes} = useStyles();
  const {contact} = useRenewalClick();
  const config = VARIANT_CONFIG[variant] || VARIANT_CONFIG.invalid;
  const whatsAppNumber = contact.whatsAppNumber;

  return (
    <div className={classes.container}>
      <Box className={`${classes.iconWrapper} ${classes.warningBg}`}>
        <ErrorOutlineIcon className={classes.warningIcon} />
      </Box>
      <Typography className={classes.title}>
        <FormattedMessage id={`${config.prefix}.title`} />
      </Typography>
      <Typography className={classes.subtitle}>
        <FormattedMessage id={`${config.prefix}.subtitle`} />
      </Typography>
      {whatsAppNumber && (
        <Button
          className={classes.whatsappBtn}
          href={`https://wa.me/${whatsAppNumber}`}
          target='_blank'
          rel='noopener noreferrer'
          startIcon={<img src={whatsappIcon} alt='' className={classes.whatsappIcon} />}
        >
          <FormattedMessage id='renewalClick.contact.whatsapp' />
        </Button>
      )}
    </div>
  );
};

InvalidLinkScreen.propTypes = {
  variant: PropTypes.oneOf(['expired', 'invalid']),
};

export default InvalidLinkScreen;
